import { AppModules } from 'appContainer/types';
import { booleanParam } from 'router/declarative/paramRegistry';
import type { PathRouteContent, RouteNode } from 'router/declarative/routeNode';

export const emptyRootHomeRedirect = {
  path: { index: true },
  redirect: { route: '/home' },
} as const satisfies RouteNode;

export const rootHomeRedirect = {
  path: '/',
  redirect: { route: '/home' },
} as const satisfies RouteNode;

// /view and /start are not officially supported routes, but kept since
// many customers have these either bookmarked or configured in their
// SSO setup. Check logs before removing these routes.
export const viewHomeRedirect = {
  path: '/view',
  redirect: { route: '/home' },
} as const satisfies RouteNode;

export const startHomeRedirect = {
  path: '/start',
  redirect: { route: '/home' },
} as const satisfies RouteNode;

export const homeRoute = {
  path: '/home',
  title: 'Home',
  appModule: AppModules.HOME,
  searchParams: { editMode: booleanParam },
  content: async (): PathRouteContent =>
    (await import('./HomeRoute')).HomeRoute,
} as const satisfies RouteNode;
